// GENERAL
import React from "react";
// COMPONENTS
import {
	BaseText,
	BaseContainer,
	AddNotesForm,
} from "../../../../../components";

// TYPES
import { ApprovalNotesSectionProps } from "../types";

const ApprovalNotesSection: React.FC<ApprovalNotesSectionProps> = ({
	adminNotes,
	activeUuid,
	toggleViewAllNotes,
	setRefetchData,
}) => {
	///// CLASS NAMES /////
	const parentContainerClasses =
		"flex flex-col items-start w-full bg-gray-100 py-2.5 px-3 rounded-xl border border-gray-200 mb-5";
	return (
		<BaseContainer
			columnContainerClasses={parentContainerClasses}
			columnShape="semi-rounded"
			borderColor="navy-200"
			isDisabled={false}
			dataTestId="approval-notes-section"
		>
			<AddNotesForm
				notesData={adminNotes}
				openViewAllNotes={toggleViewAllNotes}
				showViewAllButton={true}
				title={
					<BaseText
						text={"Notes"}
						fontFamily="font-omnes-medium"
						tag="h1"
						size="text-sm"
						color="text-navy-500"
						additionalClasses=""
					/>
				}
				showBottomNoteCount={true}
				notesPlacementBottom={true}
				refetchData={() => setRefetchData((prevState) => !prevState)}
				notesListMaxHeight="max-h-[262px] overflow-scroll"
				salesOrderUuid={activeUuid}
				addNoteButtonStyles={"bg-white"}
			/>
		</BaseContainer>
	);
};

export default ApprovalNotesSection;
